import React from 'react';
import PropTypes from 'prop-types';
import { getSkinFromStorageOrDefault } from '../../shared';

export default class Logo extends React.Component {
  static propTypes = {
    customCss: PropTypes.string
  };

  defaultLogo(customCss) {
    let css = 'logo';

    if (customCss) css = customCss;
    return (
      <div className={css}>
        <div className="word1">smart</div>
        <div className="word2">Classroom</div>
      </div>
    );
  }

  render() {
    let theme = getSkinFromStorageOrDefault();
    const { customCss } = this.props;

    let logo;

    if (theme && theme.images && theme.images.logos && theme.images.logos) {
      let srcLogo = theme.images.logos.bigLight ? theme.images.logos.bigLight : theme.images.logos.bigDark;
      if (customCss === 'logo-opaque') {
        srcLogo = theme.images.logos.bigDark;
      }

      logo = srcLogo ? <img className="logo" alt="" src={srcLogo} /> : this.defaultLogo(customCss);
    } else {
      logo = this.defaultLogo(customCss);
    }

    return <div>{logo}</div>;
  }
}
